import React, { useContext, useMemo } from 'react';

import ClassList from '../components/lists/ClassList';
import { AuthContext } from '../contexts/authContext';
import {
  useClassVehicleMap,
  useDefaultVehicles,
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierRateClassesPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const { defaultVehicles } = useDefaultVehicles();
  const { classVehicleMap } = useClassVehicleMap();
  const userHasPermission = useUserPermission();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const carrierVehicles = useMemo(
    () => [...defaultVehicles, ...(selectedCarrier?.vehicles || [])],
    [defaultVehicles, selectedCarrier?.vehicles]
  );

  if (!selectedCarrier) {
    return null;
  }

  if (!userHasPermission(selectedCarrier, 'classPermission')) {
    return null;
  }

  return (
    <Layout
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      <ClassList
        carrier={selectedCarrier}
        classVehicleMap={classVehicleMap}
        id="rate-class"
        userRole={authUser?.role}
        vehicles={carrierVehicles}
      />
    </Layout>
  );
};

export default CarrierRateClassesPage;
